import {StringUtils} from "./stringUtils";

export class FiltersLayerUtils {


    static searchChildIdsOfGroupsIds(groupsId, groups) {
        if (groupsId.length === 0) return [];

        const childGroups = groups.filter(group => groupsId.includes(group.parent_id));
        const childGroupsIds = childGroups.map(group => group.id);


        return childGroupsIds.concat(FiltersLayerUtils.searchChildIdsOfGroupsIds(childGroupsIds, groups));
    }

    static filterLayersByGroupsIds(groupsId, layers, groups) {
        let childsOfSelectedGroups = FiltersLayerUtils.searchChildIdsOfGroupsIds(groupsId, groups);

        return layers.filter(layer => {
            return (layer.viewer_group.is_published == 1 && layer.is_published == 1) && (groupsId.includes(layer.viewer_group.id) || childsOfSelectedGroups.includes(layer.viewer_group.id));

        });
    }

    static filterLayersByText(searchText, layers, locale) {
        return layers.filter(map => {
            const matchingTitle = StringUtils.compareStringsForSearch(map[`title_${locale}`], searchText);
            const description = map[`description_${locale}`] !== null ? map[`description_${locale}`] : '';
            const matchingDescription = StringUtils.compareStringsForSearch(description, searchText);

            return map.is_published && (matchingTitle || matchingDescription);
        })
    }
}